<template>
  <div id="tac-admin-payment-reconciliation-batch">
    <summary-section></summary-section>
    <transactions-section></transactions-section>
  </div><!-- #tac-admin-payment-reconciliation-batch -->
</template>

<script>
  import SummarySection from './Summary'
  import TransactionsSection from './Transactions'

  export default {
    name: 'batch',
    components: {
      SummarySection,
      TransactionsSection
    }
  }
</script>
